import PropTypes from "prop-types"
import React from "react"
import { Row, Col, Card, CardBody, Container, Label } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "lib/formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

import AuthBrandingLogo from "components/Authentication/AuthBrandingLogo"
import { resetPasswordSchema } from "components/Common/validation"
import { forgotPassword } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { getApiErrorMessage } from "utils/apiErrorMessage"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import { ROUTES } from "constants/routes"
import useAuthPageBranding from "hooks/useAuthPageBranding"

const ForgetPasswordPage = props => {
  const { t } = useTranslation()
  const { brandTitle, authPageClassName } = useAuthPageBranding(
    t("Forgot password")
  )

  const dispatch = useDispatch()
  const { loading, error, forgetError, forgetSuccessMsg, actionType } =
    useSelector(state => state.Login)

  // const { forgetSuccessMsg } = useSelector(ForgotPasswordProperties)

  const onSubmit = values => {
    dispatch(forgotPassword({ ...values, history: props.router.navigate }))
      .then(action => {
        const payload = action?.payload
        const { statusCode, status, msg } = payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(
            showAlert({
              text: getApiErrorMessage(payload, null, {
                isAuth: true,
                fallback: t("Unable to process your request. Please try again."),
              }),
              type: "error",
            })
          )
        }
      })
      .catch(error => {
        dispatch(
          showAlert({
            text: getApiErrorMessage(null, error, {
              isAuth: true,
              fallback: t("Unable to process your request. Please try again."),
            }),
            type: "error",
          })
        )
      })
  }

  return (
    <React.Fragment>
      <div
        className={`account-pages my-5 pt-sm-5 ${authPageClassName}`}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div
                  className="login-platform-hero"
                >
                  <Row>
                    <Col xs={12}>
                      <div
                        className="p-4"
                      >
                        <h5>{brandTitle}</h5>
                        <p>
                          {t("Enter your email to receive a reset link.")}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <AuthBrandingLogo />
                  <div className="p-2">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{ email: "" }}
                      validationSchema={resetPasswordSchema}
                      onSubmit={onSubmit}
                    >
                      {({ values, errors, touched, isSubmitting }) => (
                        <Form className="form-horizontal">
                          <div className="mb-3">
                            <Label className="form-label">{t("Email")}</Label>
                            <Field
                              name="email"
                              className={`form-control ${
                                touched.email && errors.email && "is-invalid"
                              }`}
                              placeholder={t("Email")}
                              type="email"
                            />
                            <TextError name="email" />
                          </div>
                          <Row className="mb-3">
                            <Col className="text-end">
                              <button
                                className="btn btn-primary w-md "
                                type="submit"
                                disabled={loading}
                              >
                                {t("Reset")}
                              </button>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center login-platform-footer">
                <p>
                  {t("Go back to")}{" "}
                  <Link
                    to={ROUTES.LOGIN}
                    className="font-weight-medium text-primary"
                  >
                    {t("Login")}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} {brandTitle}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
